import { useMutation } from '@tanstack/react-query';
import { estimateSession } from '@/api/endpoints';
import type { EstimateRequest, EstimateResponse } from '@/types/api.types';

export interface UseEstimateReturn {
  estimate: EstimateResponse | undefined;
  runEstimate: (request: EstimateRequest) => void;
  isPending: boolean;
  isError: boolean;
  error: Error | null;
  reset: () => void;
}

export function useEstimate(): UseEstimateReturn {
  const mutation = useMutation({
    mutationFn: (request: EstimateRequest) => estimateSession(request),
  });

  return {
    estimate: mutation.data,
    runEstimate: mutation.mutate,
    isPending: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    reset: mutation.reset,
  };
}
